<template>
  <div>
    <template v-if="gameName === 'genshin'">
      <div class="instruction-container">
        <span class="tip_instruction">{{
          $t(`genshin.package_instruction`)
        }}</span>
        <TipsPopover />
      </div>
    </template>

    <template v-if="gameName === 'soul-land3d'">
      <SoulLandTips />
    </template>

    <template v-if="gameName === 'free-fire'">
      <FFTips />
    </template>
  </div>
</template>
<script>
  import TipsPopover from '@page_detail/components/Tips/popover'
  import SoulLandTips from '@page_detail/components/Tips/soulLand3d'
  import FFTips from '@page_detail/components/Tips/ffTips'
  import { mapState } from 'vuex'
  export default {
    components: {
      TipsPopover,
      SoulLandTips,
      FFTips,
    },
    data() {
      return {}
    },
    computed: {
      ...mapState(['gameName']),
    },
  }
</script>
<style lang="scss" scoped>
  .instruction-container {
    display: flex;
    color: #f96000;
  }
</style>
